import type {EditionType, PrintEditionListing, ProductType} from '../../types/types.ts';
import type {ContentAdapter} from '../adapters/content-adapter.ts';
import type {Store} from '../lib/store.ts';
import type {ReaderListing} from '../pages/reader/reader-listing.ts';
import type {Article, RelatedArticle} from './article.ts';
import type {Reel} from './reel.ts';

export type ReaderItem = Article | Reel;

export abstract class ReaderEdition {
	id!: string;
	title!: string;
	productId!: string;
	productName!: string;
	editionName = '';
	productTitle!: string;
	publishDate!: string;
	description = '';
	label!: string;
	articles: ReaderItem[] = [];
	editionType!: EditionType;
	productType!: ProductType;
	latestEditions: PrintEditionListing[] | undefined;
	protected adapter: ContentAdapter;

	constructor(adapter: ContentAdapter) {
		this.adapter = adapter;
	}

	get locale(): string {
		return this.adapter.locale;
	}

	get timezone(): string {
		return this.adapter.timezone;
	}

	abstract loadArticleList(store: Store): Promise<ReaderItem[]>;
	abstract loadFullArticle(
		article: Article | Reel,
		groupBy: string,
		sortOrder: number | undefined,
		store: Store
	): Promise<Article | Reel | null>;
	abstract getSection(listing: ReaderListing): string;
	abstract getPath(): string;

	getLatestEditionPath() {
		return this.getPath();
	}

	getArticleUrl(listing: ReaderListing, pageNumber: number) {
		if (pageNumber && pageNumber > 1) {
			return `${this.getPath()}/${listing.id}/${pageNumber}`;
		}

		return `${this.getPath()}/${listing.id}`;
	}

	abstract loadRelatedArticles(article: Article): Promise<RelatedArticle[]>;
}
